import { COMMENTS_DRAWER_BREAKPOINT, MOBILE_BREAKPOINT } from "./constants";
import { ui } from "./dom";

let panelRestoreFocus: HTMLElement | null = null;

export function openNav(): void {
  if (window.innerWidth > MOBILE_BREAKPOINT) return;
  panelRestoreFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  document.body.classList.remove("comments-open");
  document.body.classList.add("nav-open", "panel-open");
  ui.sidebar.inert = false;
  ui.commentsPanel.inert = true;
  ui.pageScrim.hidden = false;
  window.setTimeout(() => ui.navCloseBtn.focus(), 20);
}

export function openComments(): void {
  if (window.innerWidth > COMMENTS_DRAWER_BREAKPOINT) {
    ui.commentsPanel.scrollIntoView({ block: "nearest" });
    return;
  }
  panelRestoreFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  document.body.classList.remove("nav-open");
  document.body.classList.add("comments-open", "panel-open");
  ui.sidebar.inert = window.innerWidth <= MOBILE_BREAKPOINT;
  ui.commentsPanel.inert = false;
  ui.pageScrim.hidden = false;
  window.setTimeout(() => ui.commentsCloseBtn.focus(), 20);
}

export function closePanels(restoreFocus = true): void {
  document.body.classList.remove("nav-open", "comments-open", "panel-open");
  ui.pageScrim.hidden = true;
  updateResponsivePanels();
  if (restoreFocus) panelRestoreFocus?.focus();
  panelRestoreFocus = null;
}

export function updateResponsivePanels(): void {
  const width = window.innerWidth;
  ui.sidebar.inert = width <= MOBILE_BREAKPOINT && !document.body.classList.contains("nav-open");
  ui.commentsPanel.inert = width <= COMMENTS_DRAWER_BREAKPOINT && !document.body.classList.contains("comments-open");
  if (width > COMMENTS_DRAWER_BREAKPOINT) {
    document.body.classList.remove("comments-open", "panel-open");
    ui.commentsPanel.inert = false;
    ui.pageScrim.hidden = true;
  }
  if (width > MOBILE_BREAKPOINT) {
    document.body.classList.remove("nav-open");
    ui.sidebar.inert = false;
  }
}
